import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import SyncAuthToStore from "./Modules/Authentication/Components/SyncAuthToStore";
import AppRouter from "./routes/AppRouter";
import useThemeStore from "./stores/useThemeStore";
import I18nProvider from "./i18n/I18nProvider";

// Apply the persisted theme synchronously at module-load time, before React
// renders a single frame.
useThemeStore.getState().applyCurrentTheme();

const App = () => {
  return (
    <I18nProvider>
      <BrowserRouter>
        <SyncAuthToStore />
        <Suspense
          fallback={
            <div className="flex items-center justify-center h-screen bg-gray-50">
              <div className="w-8 h-8 border-[3px] border-primary border-t-transparent rounded-full animate-spin" />
            </div>
          }
        >
          <AppRouter />
        </Suspense>
      </BrowserRouter>
    </I18nProvider>
  );
};

export default App;
